module.exports = __webpack_public_path__ + "img/error.cfb49f55.svg";